export default __webpack_public_path__ + "static/media/i040vk.6ffb9c45.webp";